import React from 'react';
import { injectIntl } from 'react-intl';
import { parseClasses } from '../../lib/ep.js';

const CloseButton = (props) => {
	const disabled = props?.disabled ?? false;

	const onclick = (e) => {
		if(disabled) return;
		if(props.onClick != undefined) props.onClick(e);
	};

	let classname = props?.classname ?? 'gui_close_overlayer knk-close';
	classname = parseClasses(classname, props._class, 'close_button');

	return (
		<a class={classname} onClick={onclick}>
			{(props.children) && (
				props.intl.formatMessage({ id:props.children })
			)}
		</a>
	);
}

export default injectIntl(CloseButton);